var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgChatInbox = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 32,
  height: 32,
  fill: "#1B1F23",
  "aria-hidden": "true",
  viewBox: "0 0 32 32"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M14.348 26a36.4 36.4 0 0 1-10.08 5.617 1.5 1.5 0 0 1-1.954-1.826q1.057-3.657 1.537-6.43A10.98 10.98 0 0 1 0 15v-4C0 4.925 4.925 0 11 0h10c6.075 0 11 4.925 11 11v4c0 6.075-4.925 11-11 11zm-.973-1.78.274-.22H21a9 9 0 0 0 9-9v-4a9 9 0 0 0-9-9H11a9 9 0 0 0-9 9v4a8.98 8.98 0 0 0 3.54 7.155l.473.362-.092.588q-.429 2.73-1.414 6.282a34.5 34.5 0 0 0 8.868-5.168zM8 10h8v2H8zm0 4h16v2H8z"
})));
export default SvgChatInbox;